module.exports = __webpack_public_path__ + "media/Video 10a.b80f994a.mp4";